module.exports = __webpack_public_path__ + "img/transport-icon.db514d5.svg";